<template>
  <div>
    <div class="page f-pr" @click="toIndex2">
      
      <!-- <div class="logo-row fcc">
        <img src="@/assets/logo.png" alt="">
      </div>  -->
      <div class="mid">

         <!-- <div class="slogen">
          <img src="@/assets/slogen.png" alt="">
         </div> -->

         <div class="btn-row fcc" @click="toIndex2">
           <img src="@/assets/btn-dk.png" alt="" class="gif">
         </div>
      </div>


    </div>
	
	<van-overlay :show="showLoading">
	  <div class="fcc-h " style="height: 100vh;">
	    <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
	  </div>
	</van-overlay>
  </div>
</template>

<script>

import { login } from "@/api/api";

export default {


  data() {
    return {
      member: {},
      showLoading: false,
      showRule: false
    }
  },

   async mounted() {
    this.login()
  },
  methods:{
	  login() {
      let self = this
      self.showLoading = true
      self.member.username = this.getUrlParam("unionId");
      let agmUserInfoStr = window.localStorage.getItem('agmUserInfo')
      let agmUserInfo = {}
      if (agmUserInfoStr) {
        agmUserInfo = JSON.parse(agmUserInfoStr)
      }
      if (self.member.username) {
        if (this.getUrlParam("avatarUrl")) {
          self.member.avatar = decodeURIComponent(this.getUrlParam("avatarUrl"));
        }
        if (this.getUrlParam("nickName")) {
          self.member.nickname = decodeURIComponent(this.getUrlParam("nickName"));
        }
        login(self.member).then(res => {
          if (res.success) {
            window.localStorage.setItem('agmUnionId', res.data.userInfo.username)
            window.localStorage.setItem('agmUserInfo', JSON.stringify(res.data.userInfo))
            self.member = res.data.userInfo;
          }
        }).finally(fRes => {
          self.showLoading = false
        });
      } else if (agmUserInfo && agmUserInfo.username) {
        self.member = agmUserInfo
        self.showLoading = false
      } else {
        self.showLoading = false
        this.$toast("用户信息不存在，请返回注册~")
      }
    },
		toIndex2(){
      this.$router.push('/index2')
      if (this.member.username) {
        this.$router.push('/index2')
      }else {
        this.$toast("用户信息不存在，请返回注册~")
        return
      }
		},
   getUrlParam(paraName) {
      // var url = document.location.toString();
      var url = window.location.href.toString();
      console.log(url);
      var arrObj = url.split("?");
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        console.log(arrPara);
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");
          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      }
      else {
        return "";
      }
    }
    
  }

}

</script>
<style scoped lang="less">
.gif{
	-webkit-animation: gif 1s infinite linear;
    animation: gif 1s infinite linear;
}
@keyframes gif {
  0% {
      -webkit-transform: scale(1);
      transform: scale(1);
  }
  50% {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
  }
  100% {
      -webkit-transform: scale(1);
      transform: scale(1);
  }
}
@-webkit-keyframes gif {
  0% {
      -webkit-transform: scale(1);
      transform: scale(1);
  }
  50% {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
  }
  100% {
      -webkit-transform: scale(1);
      transform: scale(1);
  }
}
.btn-row{
  position: absolute;
  left: 0;
  top: 31vh;
  right: 0;
  img{
    width: 418px;
    height: 128px;
  }
}
.logo-row{
  position: absolute;
  top: 79px;
  left: 72px;
  right: 72px;
  img{
    display: block;
    width: 100%;
  }
}
.slogen{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 8vh;

  img{
    display: block;
    width: 560px;
    height: 337px;
    margin: 0 auto;
  }
}
.mid{
  position: absolute;
  width: 100%;
  left: 0;
  top: 50%;
  height: 1px;
  // background: yellow;
}
.page {
  display: block;

  min-height: 100vh;
  background: #0CB7FC;
  background-size: 100% auto;
  // background-size: cover;
  display: flex;
  flex-direction: column;
	justify-content: end;

  >img {
    display: block;
    width: 100%;
    

  }
  background: url(../assets/bg2.png) center bottom no-repeat;
  background-size: cover;
}


.btn-submit{
  width: 184px;
  height: 184px;
  position: absolute;
  top: 1013px;
  left: 50%;
  transform: translateX(-50%);
  img{
    display: block;
    width: 100%;
  }
}


.page2-info {
  position: absolute;
  left: 172px;
  right: 94px;
  top: 672px - 16px;

  font-weight: 300;
  font-size: 26px;
  color: #000000;
  line-height: 55px;

  .left {
    font-weight: 400;
    font-size: 32px;
    color: #000000;
    line-height: 46px;
  }
  .row{
    margin-bottom: 30px;
  }
  .right{
    width: 258px;
    input{
      width: 100%;
      height: 46px;
      line-height:46px;
      padding:0 10px;
      font-size: 30px;
      color: #000;
      border: none;
    }
  }
  .p {
    
    text-align: center;
    font-size: 20px;
    font-weight: 300;
   
    color: #000000;
    line-height: 35px;
    white-space: nowrap;
  }
}

.gz {
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 50px;
  position: absolute;
  left: 93px;
  top: 880px;
  height: 245px;
  padding-top: 52px;
  // background: url(../assets/z.png) 11px 0 no-repeat;
  background-size: 245px 245px;


}
</style>